import { Milestone, PROGRESS_BAR_TYPE } from "./types";
import { PROGRESS_BAR_CONFIGURATION } from "./config";

export const getPartPercentageOfMilestones = (milestoneLength: number, index: number): number => {
  const value = PROGRESS_BAR_CONFIGURATION.partPercentageOfMilestones[milestoneLength]?.[index];
  if (!value) {
    throw new Error('Invalid milestone length or index');
  }
  return value;
}

export const getTotalProgressSoFar = (milestoneLength: number, achievedMilestoneIdx: number): number => {
  const value = PROGRESS_BAR_CONFIGURATION.partPercentageOfMilestones[milestoneLength]?.slice(0, achievedMilestoneIdx + 1).reduce((acc, curr) => acc + curr, 0);
  if (!value) {
    throw new Error('Invalid milestone length or index');
  }
  return value;
}

export const calculateProgress = (total: number, milestones: Milestone[], type: PROGRESS_BAR_TYPE) => {
  let achievedMilestoneIdx = 0;
  let currentProgress = 0;

  // Find the index of the next milestone that has not yet been achieved
  const nextMileStoneToAchieveIdx = milestones.findIndex((milestone) => milestone.milestone_amount > total);

  // All milestones have been achieved
  if (nextMileStoneToAchieveIdx === -1) {
    achievedMilestoneIdx = milestones.length - 1;
    currentProgress = 100;
    if (milestones.length === 1) {
      currentProgress = 100;
    }
  } else {
    // Determine the next milestone to achieve and the previous milestone (if any)
    const nextMileStoneToAchieve = milestones[nextMileStoneToAchieveIdx];
    achievedMilestoneIdx = nextMileStoneToAchieveIdx - 1;

    // Get the amount required to achieve the next milestone, and the last achieved milestone
    const upperToAchieveAmount = nextMileStoneToAchieve?.milestone_amount;
    let lowerAchievedAmount = 0;
    if (nextMileStoneToAchieveIdx > 0) {
      lowerAchievedAmount = milestones[nextMileStoneToAchieveIdx - 1]?.milestone_amount ?? 0;
    }
    
    if (type === PROGRESS_BAR_TYPE.DYNAMIC) {
      currentProgress = (total / (upperToAchieveAmount ?? 0)) * 100;
      return { achievedMilestoneIdx, currentProgress };
    }

    // Normalize the progress between the last achieved milestone and the next milestone
    const normalizedProgress = (total - lowerAchievedAmount) / ((upperToAchieveAmount ?? 0) - lowerAchievedAmount);
    const PART_PERCENTAGE_OF_MILESTONES = getPartPercentageOfMilestones(milestones.length, nextMileStoneToAchieveIdx);
    if (nextMileStoneToAchieveIdx === 0) {
      // If no milestones have been achieved yet
      currentProgress = PART_PERCENTAGE_OF_MILESTONES * normalizedProgress;
    } else {
      // If at least one milestone has been achieved
      const totalProgressSoFar = getTotalProgressSoFar(milestones.length, achievedMilestoneIdx);
      currentProgress = totalProgressSoFar + (PART_PERCENTAGE_OF_MILESTONES * normalizedProgress);
    }
  }

  return { achievedMilestoneIdx, currentProgress };
};
